import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsConfluenceComponent } from './simple-icons-confluence.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsConfluenceComponent ],
    exports:      [ SimpleIconsConfluenceComponent ],
    bootstrap:    []
})
export class SimpleIconsConfluenceModule {}
